import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import * as Yup from 'yup';

import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Input, Separator, Text} from '@/src/ui';

import css from '../styles/EditAcademicTitlePopupLayout.module.css';

const getValidationSchema = (t) => {
  return Yup.object().shape({
    suffixed_academic_title: Yup.string().max(
      100,
      t('validation.max-length-error', {maxLength: 100})
    ),
    prefixed_academic_title: Yup.string().max(
      50,
      t('validation.max-length-error', {maxLength: 50})
    ),
  });
};

interface EditAcademicTitlePopupLayoutProps {
  prefixedAcademicTitle?: string | null;
  suffixedAcademicTitle?: string | null;
  onSubmitClick: (...args: any[]) => any;
  onCancelClick: (...args: any[]) => any;
  isLoading: boolean;
}

const EditAcademicTitlePopupLayout = ({
  isLoading,
  onCancelClick,
  onSubmitClick,
  suffixedAcademicTitle,
  prefixedAcademicTitle,
}: EditAcademicTitlePopupLayoutProps) => {
  const {t} = useTranslation(TextLocal.LOCALE_SOURCE.COMMON);

  return (
    <div className={css.popup}>
      <div className={css.header}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          color={Text.COLOR.PRIMARY}
          fontFamily={Text.FONT_FAMILY.RUBIK}
        >
          <TextLocal id={'sing-up-add-info.edit-academic-title'} />
        </Text>
      </div>
      <Formik
        onSubmit={onSubmitClick}
        initialValues={{
          prefixed_academic_title: prefixedAcademicTitle || '',
          suffixed_academic_title: suffixedAcademicTitle || '',
        }}
        validationSchema={getValidationSchema(t)}
      >
        <Form>
          <div className={css.form}>
            <div className={css.prefixedInput}>
              {/*@ts-ignore*/}
              <Input
                placeholder={t('sing-up-add-info.prefixed-academic-title')}
                type={Input.TYPES.TEXT}
                name={'prefixed_academic_title'}
                width={Input.WIDTH.WIDTH_FULL}
              />
            </div>
            <div className={css.suffixedInput}>
              {/*@ts-ignore*/}
              <Input
                placeholder={t('sing-up-add-info.suffixed-academic-title')}
                type={Input.TYPES.TEXT}
                name={'suffixed_academic_title'}
                width={Input.WIDTH.WIDTH_FULL}
              />
            </div>
            <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
            <div className={css.buttonsBlock}>
              <div className={css.cancelPseudoButton} onClick={onCancelClick}>
                <Text
                  color={Text.COLOR.GREY}
                  fontWeight={Text.FONT_WEIGHT.MEDIUM}
                  fontSize={Text.FONT_SIZE.SIZE_16}
                >
                  <TextLocal id={'create-course.cancel'} />
                </Text>
              </div>
              <Button
                color={Button.COLOR.PRIMARY}
                height={Button.HEIGHT.REGULAR}
                type={Button.TYPES.SUBMIT}
                isLoading={isLoading}
              >
                <TextLocal id={'general.send'} />
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default EditAcademicTitlePopupLayout;
